import ApiService from './ApiService'

const UsersService = {
    resendInvite(invite) {
        return ApiService.get('invite.resend', { invite })
    },

    deleteInvite(invite) {
        return ApiService.delete('invite.destroy', { invite })
    },

    deleteRegularUser(user) {
        return ApiService.delete('user.destroy', { user })
    },

    getUserRoles(user_id) {
        return ApiService.post('user.get_user_roles', null, { user_id })
    },

    toggleUserRole(user_id, data) {
        return ApiService.post('user.toggle_user_role', data, { user_id })
    },

    sendInvite(data) {
        return ApiService.post('invite.store', data)
    },

    sendPartnerInvite(data) {
        return ApiService.post('invite.partner.store', data)
    },

    createOem(data) {
        return ApiService.post('oem.store', data)
    },

    impersonateUser(user) {
        return ApiService.get('permission.impersonate', { user })
    },
}

export default UsersService
